export default __webpack_public_path__ + "static/media/circle-filled-green.811c4012.svg";